export default __webpack_public_path__ + "static/media/Calibration.0ab74492.PNG";